import {
  trigger, animateChild, group,
  transition, animate, style, query,
  type AnimationTriggerMetadata,
} from '@angular/animations';




export function animation1(myRoute:string){

    return transition(myRoute, [
      style({ position: 'relative' }),
      query(':enter, :leave', [
        style({
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%'
        })
      ]),
      query(':enter', [
        style({ left: '-100%'})
      ]),
      query(':leave', animateChild()),
      group([
        query(':leave', [
          animate('300ms ease-out', style({ left: '100%'}))
        ]),
        query(':enter', [
          animate('300ms ease-out', style({ left: '0%'}))
        ])
      ]),
      query(':enter', animateChild()),
    ])


  }






  export function animation2(myRoute: string) {
    return transition(myRoute, [
      style({
        position: 'relative',
        // Keeps column height while :enter/:leave are position:absolute (avoids CLS).
        minHeight: 'calc(100dvh - 180px)',
      }),
      query(':enter, :leave', [
        style({
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%'
        })
      ]),
      query(':enter', [
        style({ opacity: 0 })
      ]),
      query(':leave', animateChild()),
      group([
        query(':leave', [
          animate('300ms ease-out', style({ opacity: 0 }))
        ]),
        query(':enter', [
          animate('300ms ease-out', style({ opacity: 1 }))
        ])
      ]),
      query(':enter', animateChild()),
    ]);
  }






export const slideInAnimation: AnimationTriggerMetadata = trigger('routeAnimation', [
    animation2('login <=> finish-registration'),
    animation2('finish-registration <=> login'),
    animation2('finish-registration <=> main'),
    animation2('main <=> login'),
    animation2('main <=> catalogue'),
    animation2('catalogue <=> main'),
    animation2('catalogue <=> course-details'),
    animation2('course-details <=> catalogue'),
    animation2('catalogue <=> learning-paths'),
    animation2('learning-paths <=> catalogue'),
    animation2('learning-paths <=> course-details'),
    animation2('course-details <=> learning-paths'),
    animation2('course-details <=> stack-questions')
  ]);
  
  
  




// export const slideInAnimation =  trigger('routeAnimation', [
//   animation1('login <=> finish-registration'),
//   animation1('finish-registration <=> login'),
//   animation1('finish-registration <=> main'),
//   animation1('main <=> login'),
//   animation1('main <=> catalogue'),
//   animation1('catalogue <=> main'),
//   animation1('catalogue <=> course-details'),
//   animation1('course-details <=> catalogue'),
//   animation1('course-details <=> stack-questions')

// ]);


